const profile = {
  accountEmail: '账号邮箱',
  accountEmailEn: 'Account Email',
  noEmail: '未绑定邮箱',
  membership: '会员状态',
  membershipEn: 'Membership',
  memberVip: 'VIP 会员',
  memberRegular: '非会员状态',
  memberBenefits: '查看会员权益',
  memberBenefitsTitle: '当前可用权益',
  memberBenefitsVipTitle: '试用会员权益',
  memberBenefitsRegularTip: '开通会员后可额外解锁「导入简历不限量」权益。',
  benefitsShort: '权益',
  memberBenefitUnlimitedImport: '导入简历不限量',
  memberBenefitFilters: '筛选：活跃度、看机会、年龄、职能、地址、是否中企经历',
  memberBenefitCandidateManage: '候选人管理、华人识别',
  memberBenefitLanguageEdu: '语言、学历水平',
  memberBenefitCompanyEmailName: '公司、邮箱、名字',
  memberBenefitJobHopping: '跳槽频率功能',
  vipShort: 'VIP',
  freePlan: '免费版',
  vipStatus: '会员身份',
  isVip: '已开通会员',
  planNames: {
    free: '免费版',
    vip: '会员',
    trial: '试用会员',
    basic: '基础会员',
    professional: '专业会员',
    professionalPro: '专业会员 Pro',
    team: '专业会员 Pro',
    enterpriseStandard: '企业版会员',
    enterpriseGrowth: '企业版会员',
    personal: '基础会员',
    personalQuarterly: '基础会员',
    pro: '专业版',
    business: '商业版',
    enterprise: '企业版会员',
    subscription: '会员订阅',
  },
  vipExpireAt: '会员到期时间',
  vipExpireInDays: '{days}天后过期',
  currentMembership: '当前权益来源/等级',
  entitlementProviderLegacy: '旧系统/赠送会员',
  entitlementProviderWecom: 'WeCom',
  entitlementProviderWaffo: 'Waffo',
  entitlementProviderDesc: '权益来源：{provider}。',
  membershipStatus: {
    active: '会员生效中',
    trialing: '试用中',
    canceling: '会员生效中',
    canceled: '会员已结束',
    past_due: '会员状态异常',
    expired: '会员已过期',
  },
  membershipActiveDesc: '会员权益当前可用。',
  membershipActiveUntilDesc: '会员权益有效期：{date}。',
  membershipPastDueDesc: '会员状态异常，请联系客服确认。',
  membershipEndedDesc: '会员权益已结束。',
  subscription: '自动续费订阅',
  subscriptionStatus: {
    active: '自动续费中',
    trialing: '试用中',
    canceling: '已取消自动续费',
    canceled: '会员已结束',
    past_due: '续费失败',
    expired: '会员已过期',
  },
  subscriptionTrialingDesc: '试用中，试用结束后将自动扣款。',
  subscriptionActiveDesc: '订阅生效中，将按周期自动续费。',
  subscriptionCancelingDesc: '已取消自动续费，会员权益可用至 {date}。',
  subscriptionPastDueDesc: '续费失败，请更新支付方式或重新订阅。',
  subscriptionEndedDesc: '当前订阅已结束。',
  cancelAutoRenew: '取消自动续费',
  cancelAutoRenewLoading: '正在取消...',
  cancelAutoRenewTitle: '取消自动续费',
  cancelAutoRenewDesc: '取消后当前会员权益可使用至 {date}，到期后不会再自动扣费。',
  cancelAutoRenewConfirm: '确认取消',
  cancelAutoRenewSuccess: '已取消自动续费',
  cancelAutoRenewFailed: '取消自动续费失败，请稍后重试',
  notVip: '未开通会员',
  close: '关闭',
  contactSalesTitle: '联系销售开通会员',
  contactSalesDesc: '扫描二维码或页面左下角获取会员特权。',
  contactSalesAlt: '联系销售',
  username: '用户名',
  fullName: '姓名',
  avatarUrl: '头像地址',
  switchAvatar: '切换头像',
  avatarSourceProfile: '当前头像',
  avatarSourceOther: '其他头像',
  avatarSwitched: '头像已切换',
  usernamePlaceholder: '请输入用户名',
  fullNamePlaceholder: '请输入姓名',
  avatarUrlPlaceholder: '请输入头像 URL（https://...）',
  updateBasicInfo: '更新基本信息',
  updating: '更新中...',
  updateSuccess: '更新成功',
  updateFailed: '更新失败',
  noChanges: '没有变更，无需更新',
  invalidAvatarUrl: '头像地址格式不正确',
  guest: '访客',
  user: '用户',
  notLoggedIn: '未登录',
  unknownUser: '未知用户',
  socialConnections: '社交账号绑定',
  socialConnectionsEn: 'Social Connections',
  link: '绑定',
  linked: '已绑定',
  unlink: '解绑',
  google: 'Google',
  feishu: '飞书',
  facebook: 'Facebook',
  linkedin: 'LinkedIn',
  linkSuccess: '绑定成功',
  unlinkSuccess: '解绑成功',
  linkFailed: '绑定失败',
  linkSessionInvalid: '绑定会话校验失败，请从个人中心重新发起绑定',
  linkSessionExpired: '绑定会话已过期，请重新发起绑定',
  unlinkFailed: '解绑失败',
  unlinkConfirmTitle: '确认解绑',
  unlinkConfirmMessage: '确定要解除 {provider} 绑定吗？',
  connectorIdMissing: '未配置 Connector ID，请检查代码配置',
  notLinkedYet: '当前社交账号尚未绑定',
  verificationIdTitle: '安全验证',
  verificationMethodPrompt: '请选择敏感操作验证方式，推荐优先使用邮箱验证码',
  verifyByPassword: '使用EasyHireAI账户密码验证',
  verifyByEmail: '使用邮箱验证码',
  continueWithEmail: '继续使用邮箱验证码',
  passwordPrompt: '请输入当前账号密码以继续',
  passwordPlaceholder: '请输入密码',
  passwordRequired: '密码不能为空',
  setPassword: '去设置密码',
  passwordSetupHint: '当前账号还未设置 EasyHireAI 密码，绑定时会优先使用邮箱验证码。',
  passwordSetupGuidePrompt:
    '当前账号仅使用社交登录，尚未设置 EasyHireAI 密码。本次可继续使用邮箱验证码完成验证；如果后续希望使用密码验证，请先设置密码。',
  noEmailPasswordSetupPrompt:
    '当前账号没有可用于验证的邮箱，且尚未设置 EasyHireAI 密码。请先设置密码后再重试。',
  verificationCodeSent: '验证码已发送到当前账号邮箱',
  emailCodePrompt: '请输入发送到 {email} 的 6 位验证码',
  emailCodePlaceholder: '请输入验证码',
  emailCodeRequired: '验证码不能为空',
  noEmailForVerification: '当前账号未绑定邮箱，无法使用邮箱验证',
}

export default profile
